import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1cc37a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "probability-preview" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 加载中... ")
const _hoisted_4 = {
  key: 1,
  class: "text-center py-4 text-muted"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-3 text-muted small" }, [
  /*#__PURE__*/_createElementVNode("p", null, "* 概率 = 卡牌权重 / 总权重 × 100%"),
  /*#__PURE__*/_createElementVNode("p", null, "* 实际抽取概率可能受保底机制影响")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_icon, { class: "is-loading" }, {
            default: _withCtx(() => [
              _createVNode(_component_Loading)
            ]),
            _: 1
          }),
          _hoisted_3
        ]))
      : (_ctx.probabilityList.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 暂无卡牌数据 "))
        : (_openBlock(), _createBlock(_component_el_table, {
            key: 2,
            data: _ctx.probabilityList,
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "card_name",
                label: "卡牌名称",
                width: "180"
              }),
              _createVNode(_component_el_table_column, {
                label: "稀有度",
                width: "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_tag, {
                    type: _ctx.getRarityTagType(row.rarity),
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.rarity_display || row.rarity), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "weight",
                label: "权重",
                width: "80"
              }),
              _createVNode(_component_el_table_column, {
                label: "概率",
                width: "120"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.getProbabilityClass(row.probability))
                  }, _toDisplayString(row.probability_display), 3)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])),
    _hoisted_5
  ]))
}